<template>
  <div class="d-post-poll-types grid-2">
    <a
      v-for="pollType in pollTypes"
      :key="pollType.key"
      class="poll-type grid-item"
      @click="selectPollType(pollType)"
    >
      <span>{{ pollType.label }}</span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    pollTypes: {
      type: Object,
      required: true,
    },
  },
  methods: {
    selectPollType(pollType) {
      this.$emit('poll-type-selected', pollType);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-post-poll-types {
  .poll-type {
    background-color: getColor($grey);
    border: $border-width-base solid transparent;
    border-radius: $border-radius-lg;
    height: 160px;
    position: relative;

    @include transition((
      border-color
    ));

    &:hover {
      border-color: getColor($yellow);
    }

    span {
      color: getColor($grey, dark);
      font-weight: normal;
      left: 50%;
      position: absolute;
      text-align: center;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 90%;
    }
  }
}
</style>
